import React, { useEffect, useState } from 'react'
import { Box, Flex, Image, Modal, Stack, Text } from '@mantine/core'
import { pointRecords } from '../../../api/merchantService'
import { MerchantPointRecordVO } from '../../../typings/merchant'
import { getEnumByName } from '../../../api/dictionaryService'

interface PointsRecordModalProps {
  opened: boolean
  onClose: () => void
  pointsPerLotteryNum?: number
  currentPoints?: number
  lotteryChances?: number
}

const PointsRecordModal: React.FC<PointsRecordModalProps> = ({
  opened,
  onClose,
  pointsPerLotteryNum = 0,
  currentPoints = 0,
  lotteryChances = 0,
}) => {
  const [records, setRecords] = useState<MerchantPointRecordVO[]>([])
  const [sourceTypeMap, setSourceTypeMap] = useState<Record<string, any>>()

  useEffect(() => {
    if (opened) {
      Promise.all([pointRecords(), getEnumByName('com.isaac.common.enumeration.MerchantPointRecordTypeEnum')])
        .then(([recordsData, enumMap]) => {
          setRecords(recordsData)
          setSourceTypeMap(enumMap)
        })
        .catch()
    }
  }, [opened])

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      padding={0}
      zIndex={1100}
      overlayProps={{ opacity: 0.9 }}
      styles={{
        body: { padding: 0, background: 'transparent', boxShadow: 'none' },
        content: { background: 'transparent', boxShadow: 'none' },
      }}
    >
      <Image src="/pointsRecord.png" alt="积分记录" />
      <div style={{ background: '#fff' }}>
        {/* 抽奖规则说明区域 */}
        {pointsPerLotteryNum > 0 && (
          <Box
            style={{
              background: 'linear-gradient(135deg, #FFF8F0 0%, #FFF2E6 100%)',
              margin: '0 16px',
              padding: '12px 16px',
              borderRadius: 8,
              border: '1px solid rgba(255, 173, 33, 0.2)',
            }}
          >
            <Text
              size="sm"
              fw={600}
              style={{
                color: '#FF8C00',
                marginBottom: 8,
                display: 'flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              🎯 抽奖规则说明
            </Text>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <Text size="xs" style={{ color: '#666' }}>
                • 每 <span style={{ color: '#FF5A5A', fontWeight: 600 }}>{pointsPerLotteryNum}积分</span> 可获得
                1次抽奖机会
              </Text>
              <Text size="xs" style={{ color: '#666' }}>
                • 当前积分：<span style={{ color: '#FF5A5A', fontWeight: 600 }}>{currentPoints.toLocaleString()}</span>
              </Text>
              <Text size="xs" style={{ color: '#666' }}>
                • 可抽奖次数：<span style={{ color: '#FF5A5A', fontWeight: 600 }}>{lotteryChances}次</span>
              </Text>
              {currentPoints < pointsPerLotteryNum && (
                <Text size="xs" style={{ color: '#999' }}>
                  • 还需{' '}
                  <span
                    style={{
                      color: '#FF8C00',
                      fontWeight: 600,
                    }}
                  >
                    {pointsPerLotteryNum - currentPoints}积分
                  </span>{' '}
                  可获得下次抽奖机会
                </Text>
              )}
            </div>
          </Box>
        )}

        <div
          style={{
            padding: '16px 24px 0 24px',
            minHeight: 120,
            maxHeight: 200,
            overflowY: 'auto',
            scrollbarWidth: 'thin',
          }}
        >
          <Text
            size="sm"
            fw={600}
            style={{
              color: '#333',
              marginBottom: 12,
              paddingBottom: 8,
              borderBottom: '1px solid #F0F0F0',
            }}
          >
            📊 积分明细记录
          </Text>

          <Stack gap={0}>
            {records.length > 0 ? (
              records.map((record, idx) => (
                <div key={idx}>
                  <Flex justify="space-between" align="center" py={12}>
                    <Text c={'#3D3D3D'} size="sm">
                      {sourceTypeMap[record.sourceType]}
                    </Text>
                    <Flex gap={8} align="center">
                      <Text size="sm" fw={600} c={Number(record.pointsChange) < 0 ? '#FF5A5A' : '#00B42A'}>
                        {Number(record.pointsChange) > 0 ? '+' : ''}
                        {record.pointsChange}
                      </Text>
                      <Text c={'#999999'} size="xs">
                        {new Date(record.createTime).toLocaleDateString()}
                      </Text>
                    </Flex>
                  </Flex>
                  {idx !== records.length - 1 && <div style={{ height: '1px', background: '#DFDFDF' }} />}
                </div>
              ))
            ) : (
              <Flex direction="column" align="center" justify="center" h={80}>
                <Text c="#999999" size="sm">
                  暂无积分记录
                </Text>
              </Flex>
            )}
          </Stack>
        </div>
        <Image src={'/iknow.png'} onClick={onClose} />
      </div>
    </Modal>
  )
}

export default PointsRecordModal
